import React from "react";

import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import Card from 'react-bootstrap/Card';
import CardGroup from 'react-bootstrap/CardGroup';
import { Message } from 'primereact/message';

import { RiskLevels, ConsequenceLevels, ProbabilityLevels } from './RiskLevels'

import RiskHeatmap from "./RiskHeatmap";

class RiskAssessment extends React.Component {

	state = {
		risk: {
			riskID: 0,
			name: '',
			process: '',
			category: 1,
			owner: 0,
			description: '',
			rootCause: '',
			potentialConsequence: '',
			consequence: 1,
			probability: 1,
			
		},
		riskAfter: { probabilityAfter: 1, consequenceAfter: 1 },
		warningText:'',
	};


	componentDidMount() {

	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps !== this.props) {
			if (Object.keys(this.props.risk).length > 0) { 
				this.setState({ risk: this.props.risk });
			}
			if (prevProps.riskAfter !== this.props.riskAfter) {
				this.setState({ riskAfter: this.props.riskAfter });
				
				if (this.state.risk.probability < this.props.riskAfter.probabilityAfter) {
					this.setState({ warningText: 'Probability higher after controls/mitigations' });
				} else if (this.state.risk.consequence < this.props.riskAfter.consequenceAfter) {
					this.setState({ warningText: 'Consequence higher after controls/mitigations' });
				} else if (this.state.risk.probability * this.state.risk.consequence <= this.props.riskAfter.probabilityAfter * this.props.riskAfter.consequenceAfter) {
					this.setState({ warningText: 'No change in risk after controls/mitigations does not make sense' });
				}
				else if (this.props.riskAfter.warning) {
					this.setState({ warningText: 'The agregated risk after controls/mitigations is ok but one or more of the controls/mitigationshave may contain errors' });					
				} else {
					this.setState({ warningText: '' });
				}
			} 
		}
	}

	handleInput(event, field) {
		const value = event.target.value;
		if (this.props.onChange) {
			this.props.onChange(field, value);
		}
	}

	render() {
		const riskBgColor = RiskLevels[this.state.risk.consequence - 1][this.state.risk.probability - 1].bgColor;
		const riskColor = RiskLevels[this.state.risk.consequence - 1][this.state.risk.probability - 1].color;
		const futureRiskBgColor = RiskLevels[this.state.riskAfter.consequenceAfter - 1][this.state.riskAfter.probabilityAfter - 1].bgColor;
		const futureRiskColor = RiskLevels[this.state.riskAfter.consequenceAfter - 1][this.state.riskAfter.probabilityAfter - 1].color;
		var riskHistory = [];
		if (this.state.risk && this.state.risk.riskHistory) {
			for (var i = 0; i < this.state.risk.riskHistory.length; i++) {
				riskHistory.push({ probability: this.state.risk.riskHistory[i].probability, consequence: this.state.risk.riskHistory[i].consequence, date: new Date(this.state.risk.riskHistory[i].date.getTime()) });
			} 
			//riskHistory = [...this.state.risk.riskHistory];
			//riskHistory = JSON.parse(JSON.stringify(this.state.risk.riskHistory));
		}
		const heatMapRisk = {
			riskID: this.state.risk.riskID,
			riskName: this.state.risk.name,
			consequence: this.state.risk.consequence,
			probability: this.state.risk.probability,
			riskHistory: riskHistory,
			consequenceHistory: 5,
			probabilityHistory: 5,
			consequenceAfter: this.state.riskAfter.consequenceAfter,
			probabilityAfter: this.state.riskAfter.probabilityAfter
		};
		

		return (
			<div style={{ flexWrap: 'wrap', display: 'flex', width: '100%', flexDirection: 'row', flexBasis: 'auto', paddingLeft: '1rem', paddingRight: '1rem'  }}>

				<Card style={{ maxWidth: '20rem', minWidth: '25rem', margin: '1.5rem', marginLeft: '0' }}>
					<Card.Header>
						<b>Risk assessment</b>
					</Card.Header>
					<Card.Body style={{ padding: '0px' }}>
						<div className="p-fluid w-full" style={{ padding: '2rem' }}>
							<div className="p-field">
								<label className="p-field-label">Probability</label>
								<Dropdown value={this.state.risk.probability} onChange={(e) => { this.handleInput(e, 'probability'); }} options={ProbabilityLevels} optionLabel="text" optionValue="id" placeholder=" " className="w-full md:w-20rem" />
							</div>

							<div className="p-field">
								<label className="p-field-label">Consequence</label>
								<Dropdown value={this.state.risk.consequence} onChange={(e) => { this.handleInput(e, 'consequence'); }} options={ConsequenceLevels} optionLabel="text" optionValue="id" placeholder=" " className="w-full md:w-20rem" />
							</div>

							<div className="p-field">
								<label className="p-field-label">Risk</label>
								<InputText value={RiskLevels[this.state.risk.consequence - 1][this.state.risk.probability - 1].label} style={{ backgroundColor: riskBgColor, color: riskColor}} className="w-full md:w-20rem" />
							</div>
						</div>
					</Card.Body>
				</Card>

				<Card className='rounded' style={{ maxWidth: '20rem', minWidth: '25rem', margin: '1.5rem', marginLeft: '0' }}>
					<Card.Header>
						<b>Risk assessment after controls and mitigations</b>
					</Card.Header>
					<Card.Body style={{ padding: '0px'}}>
						<div className="p-fluid w-full" style={{ padding: '2rem' }}>
							{this.state.warningText !== '' ? <Message severity="warn" text={this.state.warningText} /> : null}
								
							<div className="p-field">
								<label className="p-field-label">Probability after controls/mitigations</label>
								<InputText value={ProbabilityLevels[this.state.riskAfter.probabilityAfter - 1].text} className="w-full md:w-20rem" />
							</div>

							<div className="p-field">
								<label className="p-field-label">Consequence after controls/mitigations</label>
								<InputText value={ConsequenceLevels[this.state.riskAfter.consequenceAfter - 1].text} className="w-full md:w-20rem" />
							</div>

							<div className="p-field">
								<label className="p-field-label">Risk after controls/mitigations</label>
								<InputText value={RiskLevels[this.state.riskAfter.consequenceAfter - 1][this.state.riskAfter.probabilityAfter - 1].label} style={{ backgroundColor: futureRiskBgColor, color: futureRiskColor }} className="w-full md:w-20rem" />
							</div>
						</div>
					</Card.Body>
				</Card>

				
				<RiskHeatmap heatMapRisk={heatMapRisk} />
				
			</div>
			
		)
	}
}
export default RiskAssessment;

								/*
								<div className="p-field md:w-30rem" style={{ float: 'left', minWidth: '25rem', margin: '5px' }} >
					<RiskHeatmap risk={this.state.risk} />
				</div>
				*/